import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const titleComment: AdminBlockTypeAttribute = {
  label: 'Show title comment',
  key: 'titleComment',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default titleComment;
